import { ChangeDetectionStrategy, Component, OnInit, ViewChild } from '@angular/core';
import { Store, select } from '@ngrx/store';
import { AppState } from 'app/app.reducers';
import { Observable } from 'rxjs';
import { AdminUserListModel } from '../../shared/models';
import { getAdminUserFilterSettings, getAdminUsers } from '../../admin-store/admin.selectors';
import { LoadAdminUsersAction } from '../../admin-store';
import { AdminUserListComponent } from '../../components/admin-user-list/admin-user-list.component';

@Component({
  templateUrl: './admin-users.component.html',
  styleUrls: ['./admin-users.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class AdminUsersComponent implements OnInit {

  @ViewChild('adminUserList', { static: false }) adminUserList: AdminUserListComponent;

  adminUsers$: Observable<AdminUserListModel[]>;
  userFilterSettings$: Observable<string>;

  constructor(private store: Store<AppState>) {
    this.adminUsers$ = this.store.pipe(select(getAdminUsers));
    this.userFilterSettings$ = this.store.pipe(select(getAdminUserFilterSettings));
  }

  ngOnInit() {
    this.userFilterSettings$.subscribe(filter => {
      this.store.dispatch(new LoadAdminUsersAction(filter));
    });
  }

  onFilterChanged(filter: string) {
    this.store.dispatch(new LoadAdminUsersAction(filter));
  }

  onExportToExcel() {
    this.adminUserList.exportExcel();
  }
}
